import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";

@Component({
  selector: "scaffold-flex-row",
  templateUrl: "./flex-row.component.html",
  styleUrls: ["../../rendered.component.scss", "./flex-row.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlexRowComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getFlexClass(list) {
    // console.log(this.item)
    var klass = list.is_hidden ? "flex-column-0" : list.flex_width;
    if (list.hasOwnProperty("background")) {
      klass += " " + list.background;
    }
    return klass;
  }
}
